import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { delayedRefundOrdersAction } from '../../redux/actions/orderActions';
import { useSearchParams } from 'react-router-dom';

const Filters = ({ page, setPage, dateFrom, dateTo }) => {


    const dispatch = useDispatch()

    const { user } = useSelector(state => state.verifyEmailStore);
    const { message } = useSelector(state => state.order)




    const [searchParams, setSearchParams] = useSearchParams();



    const [filter_count, setFilter_count] = useState(0);
    const [perPage, setPerPage] = useState('10');
    const [seller_id, setSeller_id] = useState('');
    const [pm_id, setPm_id] = useState('');
    const [productID, setProductId] = useState('');
    const [order_id, setOrder_id] = useState("");
    const [days, setdays] = useState("");






    useEffect(() => {

        const query = {}

        if (pm_id) query.pm_id = pm_id
        if (seller_id) query.seller_id = seller_id
        if (productID) query.productID = productID
        if (order_id) query.order_id = order_id
        if (perPage) query.perPage = perPage
        if (days) query.days = days

        query.page = page

        // 🚫 Do NOT include dates in URL
        setSearchParams(query)

        // ✅ Add dates only for API
        if (dateFrom) query.dateFrom = dateFrom
        if (dateTo) query.dateTo = dateTo

        dispatch(delayedRefundOrdersAction(query))

    }, [
        dateFrom,
        dateTo,
        seller_id,
        productID,
        perPage,
        page,
        pm_id,
        order_id,
        dispatch,
        message,
        setSearchParams,
        days
    ])




    useEffect(() => {

        setPerPage(searchParams.get("perPage") || "10")
        setSeller_id(searchParams.get("seller_id") || "")
        setPm_id(searchParams.get("pm_id") || "")
        setProductId(searchParams.get("productID") || "")
        setOrder_id(searchParams.get("order_id") || "")
        setdays(searchParams.get("days") || "")


    }, [searchParams, setPage])






    useEffect(() => {

        setFilter_count(0)

        if (seller_id) {
            setFilter_count(prev => prev + 1)
        }
        if (pm_id) {
            setFilter_count(prev => prev + 1)
        }
        if (productID) {
            setFilter_count(prev => prev + 1)
        }
        if (order_id) {
            setFilter_count(prev => prev + 1)
        }

    }, [seller_id, pm_id, productID, order_id])




    useEffect(() => {




        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("delayed-refunds");
        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");


        document.title = `ALL ORDERS - Admin Panel`;

    }, []);



    return (
        <Fragment>
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6 mt-4">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
                        <i className="fa-solid fa-filter text-sm"></i>
                    </div>
                    <span className='text-[0.9vmax] font-bold text-gray-700 uppercase tracking-wider'>Filter Results</span>
                    {filter_count > 0 && (
                        <span className="ml-2 px-2 py-0.5 bg-indigo-100 text-indigo-600 rounded-full text-[0.7vmax] font-bold">
                            {filter_count} Active
                        </span>
                    )}
                </div>

                <div className="flex items-center gap-3">
                    <span className='text-[0.85vmax] font-bold text-gray-400'>Items per page:</span>
                    <div className="relative">
                        <select 
                            className="appearance-none bg-white border border-gray-200 pl-4 pr-10 py-2 rounded-xl text-[0.9vmax] font-bold text-gray-700 outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all cursor-pointer shadow-sm"
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(e.target.value)
                                setPage(1)
                            }}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <i className="fa-solid fa-chevron-down absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-[0.7vmax]"></i>
                    </div>
                </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
                    <div className="space-y-1.5">
                        <label className="text-[0.75vmax] font-bold text-gray-500 ml-1">Delay Days</label>
                        <div className="relative group">
                            <i className="fa-solid fa-clock absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                            <input 
                                type="number" 
                                className="w-full bg-gray-50/50 pl-11 pr-4 py-2.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium" 
                                placeholder="Min days..."
                                value={days}
                                onChange={(e) => {
                                    setdays(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    </div>

                    <div className="space-y-1.5">
                        <label className="text-[0.75vmax] font-bold text-gray-500 ml-1">Order ID</label>
                        <div className="relative group">
                            <i className="fa-solid fa-hashtag absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                            <input 
                                type="text" 
                                className="w-full bg-gray-50/50 pl-11 pr-4 py-2.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium" 
                                placeholder="Search ID..."
                                value={order_id}
                                onChange={(e) => {
                                    setOrder_id(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    </div>

                    <div className="space-y-1.5">
                        <label className="text-[0.75vmax] font-bold text-gray-500 ml-1">Product ID</label>
                        <div className="relative group">
                            <i className="fa-solid fa-box absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                            <input 
                                type="text" 
                                className="w-full bg-gray-50/50 pl-11 pr-4 py-2.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium" 
                                placeholder="Search ID..."
                                value={productID}
                                onChange={(e) => {
                                    setProductId(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    </div>

                    {user?.role !== 'PMM' && (
                        <div className="space-y-1.5">
                            <label className="text-[0.75vmax] font-bold text-gray-500 ml-1">Seller ID</label>
                            <div className="relative group">
                                <i className="fa-solid fa-shop absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                                <input 
                                    type="text" 
                                    className="w-full bg-gray-50/50 pl-11 pr-4 py-2.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium" 
                                    placeholder="Search ID..."
                                    value={seller_id}
                                    onChange={(e) => {
                                        setSeller_id(e.target.value)
                                        setPage(1)
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {user?.role !== 'PM' && (
                        <div className="space-y-1.5">
                            <label className="text-[0.75vmax] font-bold text-gray-500 ml-1">PM ID</label>
                            <div className="relative group">
                                <i className="fa-solid fa-user-tie absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                                <input 
                                    type="text" 
                                    className="w-full bg-gray-50/50 pl-11 pr-4 py-2.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium" 
                                    placeholder="Search ID..."
                                    value={pm_id}
                                    onChange={(e) => {
                                        setPm_id(e.target.value)
                                        setPage(1)
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {filter_count > 0 && (
                    <div className="flex justify-end mt-6 pt-4 border-t border-gray-50">
                        <button 
                            className="flex items-center gap-2 px-6 py-2 rounded-xl text-red-500 font-bold text-[0.85vmax] hover:bg-red-50 transition-all active:scale-95"
                            onClick={() => {
                                setSeller_id("")
                                setPm_id("")
                                setProductId("")
                                setOrder_id("")
                                setdays("")
                            }}
                        >
                            <i className="fa-regular fa-trash-can"></i>
                            Clear All Filters
                        </button>
                    </div>
                )}
            </div>
        </Fragment>
    )
}

export default Filters